import { Component, InputSignal, inject, input } from '@angular/core';
import { LAYOUT_BREAKPOINT } from '../../../tokens/layout-breakpoint.token';
import { AppNavigation } from '../../../types/navigation.types';
import { BaseComponent } from '../../base/base.component';
import { HeaderNavigationDesktopComponent } from './desktop/header-navigation-desktop.component';
import { HeaderNavigationMobileComponent } from './mobile/header-navigation-mobile.component';

@Component({
  selector: 'immo-header-navigation',
  imports: [HeaderNavigationDesktopComponent, HeaderNavigationMobileComponent],
  templateUrl: './header-navigation.component.html',
})
export class HeaderNavigationComponent extends BaseComponent {
  // -----------------------------------------------------------------------------------------------------
  // @ DEPENDENCIES
  // -----------------------------------------------------------------------------------------------------

  readonly breakpoint = inject(LAYOUT_BREAKPOINT).headerBreakpoint;

  // -----------------------------------------------------------------------------------------------------
  // @ INPUTS
  // -----------------------------------------------------------------------------------------------------

  readonly navigation: InputSignal<AppNavigation> = input.required<AppNavigation>();
}
